export default "__VITE_ASSET__DZSWGw1V__"